import { ShieldCheck } from 'lucide-react';
import React from 'react';

interface LoadingScreenProps {
  appName?: string;
  logoUrl?: string;
  primaryColor?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  appName = 'Hommi',
  logoUrl,
}) => {
  return (
    <div className="h-screen w-screen light-glass-bg relative overflow-hidden flex flex-col items-center justify-center">
      {/* Orbes sutiles de fondo */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-80 h-80 bg-purple-200 rounded-full blur-3xl light-orb opacity-60" />
        <div
          className="absolute bottom-1/4 right-1/4 w-72 h-72 bg-indigo-200 rounded-full blur-3xl light-orb opacity-60"
          style={{ animationDelay: '-3s' }}
        />
        <div
          className="absolute top-1/2 left-1/2 w-64 h-64 bg-violet-100 rounded-full blur-3xl light-orb opacity-40"
          style={{ animationDelay: '-5s' }}
        />
      </div>

      {/* Liquid Blob Container */}
      <div className="relative z-10">
        {/* Glow sutil detrás del blob */}
        <div className="absolute inset-0 bg-purple-400 rounded-full blur-2xl opacity-20 scale-125" />

        {/* Liquid Blob */}
        <div className="relative w-28 h-28 gradient-primary liquid-blob-light flex items-center justify-center shadow-xl shadow-purple-500/20">
          {/* Logo inside blob */}
          {logoUrl ? (
            <img
              src={logoUrl}
              alt="Logo"
              className="w-10 h-10 object-contain"
            />
          ) : (
            <ShieldCheck className="w-10 h-10 text-white" />
          )}
        </div>
      </div>

      {/* App name and loading text */}
      <div className="relative z-10 mt-6 text-center">
        <h1 className="text-xl font-bold text-slate-800 mb-1 tracking-wide">
          {appName}
        </h1>

        {/* Loading dots */}
        <div className="flex items-center justify-center gap-1.5 text-slate-500 text-sm">
          <span>Cargando</span>
          <span className="flex gap-1">
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                className="w-1.5 h-1.5 bg-purple-500 rounded-full animate-bounce"
                style={{
                  animationDelay: `${i * 150}ms`,
                  animationDuration: '0.6s',
                }}
              />
            ))}
          </span>
        </div>
      </div>

      {/* Progress bar */}
      <div className="relative z-10 mt-4 w-40">
        <div className="h-1 bg-slate-200 rounded-full overflow-hidden">
          <div className="h-full gradient-primary rounded-full animate-loading-bar" />
        </div>
      </div>

      {/* Bottom branding */}
      <div className="absolute bottom-8 text-center z-10">
        <p className="text-slate-400 text-xs">
          Powered by <span className="text-purple-500 font-medium">Hommi</span>
        </p>
      </div>
    </div>
  );
};
